/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { factoryT, factoryTBuilder, fields } from 'factory-t';
import { YEAR } from '../../../components/RegistryWidgets/Devices/DeviceCard/WorkabilityChart/WorkabilityChartConfig';
import { StoreType } from '../stores/storesClientTypings';
import {
    DeviceDetailsDto,
    FirmwareHistoryItemDto,
    DeviceStatus,
    DeviceUSBType,
    DeviceWorkability,
    StatusHistoryItemDto,
    OperatorHistoryItemDto,
    RegistrationHistoryItemDto,
    DeviceDto,
} from './devicesClient.typing';

export const deviceDtoFactory = factoryTBuilder<DeviceDto>({
    factoryNumber: (ctx) => `043540007233456245678348654565${ctx.index}`,
    status: fields.sequence([
        DeviceStatus.LOST,
        DeviceStatus.FIXED,
        DeviceStatus.BROKEN,
        DeviceStatus.PRODUCED,
        DeviceStatus.STORE,
    ]),
    statusDate: '2023-02-10T10:57:32.183',
    statusComment: 'This is some status comment',
    usbType: fields.sequence([DeviceUSBType.microB, DeviceUSBType.microB, DeviceUSBType.A]),
    firmwareVersion: 'v1.43.2.0',
    wearout: fields.sequence([350000, 0, 4000000]),
    age: fields.sequence([575, 0, 900]),
    experience: fields.sequence([500, 0, 800]),
    workability: fields.sequence([
        DeviceWorkability.NEW,
        DeviceWorkability.JUNIOR,
        DeviceWorkability.SENIOR,
        DeviceWorkability.VETERAN,
        DeviceWorkability.INVALID,
    ]),
    operatorName: fields.sequence(['Operator_name1', null, 'Operator_name3']),
    operatorTaxNumber: fields.sequence(['342342881', null, '2342424']),
    cashBoxTaxNumber: '23423423423',
    cashRegisterFactoryNumber: '6666',
    storeTaxNumber: '67800033',
    companyTaxNumber: '888888',
}).factory();

export const deviceDetailsFactory = factoryTBuilder<DeviceDetailsDto>({
    factoryNumber: (ctx) => `04354000723234242342342423423466${ctx.index}`,
    usbType: fields.sequence([DeviceUSBType.microB, DeviceUSBType.A]),
    status: fields.sequence([
        DeviceStatus.LOST,
        DeviceStatus.FIXED,
        DeviceStatus.READY,
        DeviceStatus.PRODUCED,
        DeviceStatus.STOCK,
    ]),
    statusDate: 1615274301,
    statusComment:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
    firmwareVersion: 'v1.43.2.0',
    wearout: 564847,
    age: 8.5 * YEAR,
    experience: 1 * YEAR,
    workability: DeviceWorkability.VETERAN,
    operatorTaxNumber: '232342342',
    operatorName: 'Some operator long name. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    cashBoxTaxNumber: '2342342342',
    temporary: true,
    cashBoxStatus: fields.sequence(['REGISTRATION', 'ACTIVE']),
    cashRegisterFactoryNumber: '123123123',
    cashRegisterModelName: 'Model23',
    cashRegisterModelTaxNumber: '23456456454',
    storeTaxNumber: '23423423',
    storeName: 'Shtolle',
    fullAddress: 'Minsk Gintovta st. 23',
    storeType: StoreType.ENTERTAINMENT,
    storeStatus: 'ACTIVE',
    companyTaxNumber: '1234234234',
    companyName: 'Some company',
    companyStatus: 'ACTIVE',
    productionId: '6as3f81a0f2s',
    productionPlace: 'Factory name',
    productionDate: '2023-02-10T10:57:32.183',
    hardwareVersion: '1.1.0',
}).factory();

export const firmwareHistoryItemFactory = factoryT<FirmwareHistoryItemDto>({
    firmwareVersion: (ctx) => `v1.${ctx.index}.${1 + ctx.index}`,
    insertedDateAtUtc: '2023-10-16T12:14:19.422678',
    duration: fields.sequence([345, 456, 4, 5677, 654]),
});

export const statusHistoryItemFactory = factoryT<StatusHistoryItemDto>({
    status: fields.sequence([
        DeviceStatus.LOST,
        DeviceStatus.FIXED,
        DeviceStatus.PRODUCED,
        DeviceStatus.READY,
        DeviceStatus.STOCK,
        DeviceStatus.STORE,
        DeviceStatus.BROKEN,
    ]),
    insertedDateAtUtc: '2023-10-16T12:14:19.422678',
    duration: fields.sequence([345, 456, 4, 5677, 654]),
});

export const operatorHistoryItemFactory = factoryT<OperatorHistoryItemDto>({
    operatorName: (ctx) => `Operator_name_${ctx.index}`,
    operatorTaxNumber: (ctx) => `043540007${ctx.index}`,
    insertedDateAtUtc: '2023-10-16T12:14:19.422678',
    duration: fields.sequence([345, 456, 4, 5677, 654]),
});

export const registrationHistoryItemFactory = factoryT<RegistrationHistoryItemDto>({
    taxNumber: (ctx) => `543543407${ctx.index}`,
    insertedDate: '2023-02-20T10:15:00.528',
    eliminatedDate: '2023-02-20T10:15:00.528',
    duration: fields.sequence([345, 456, 4, 5677, 654]),
});
